import React from 'react';

import useContributorPermission from '../hooks/useContributorPermission';

const withContributorPermissions = getContributorPermissionProps => {
  return WrappedComponent => props => {
    const {
      isContributor,
      isAllowed,
      contributorHierarchy,
      loadingPermissions,
      contributorAssignment,
      contributorHierarchyRecord,
      isOwner,
    } = useContributorPermission(
      getContributorPermissionProps ? getContributorPermissionProps(props) : {},
    );

    return (
      <WrappedComponent
        isContributor={isContributor}
        isAllowed={isAllowed}
        isOwner={isOwner}
        contributorHierarchy={contributorHierarchy}
        loadingPermissions={loadingPermissions}
        contributorAssignment={contributorAssignment}
        contributorHierarchyRecord={contributorHierarchyRecord}
        {...props}
      />
    );
  };
};

export default withContributorPermissions;
